/* eslint-disable
    consistent-return,
    default-case,
    prefer-rest-params
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import {Arc, DefaultArcObject} from 'd3';

import * as selectioncontextmenu from 'components/SelectionContextMenu';
import {MenuChoicesOptions} from 'components/SelectionContextMenuHelpers';
import arcs from 'molbio/maps/circular/Arcs';
import {RingLayout} from 'molbio/maps/circular/CircularLayout';
import LabeledSegmentsRingView from 'molbio/maps/circular/LabeledSegmentsRingView';
import {RingComponentOptions} from 'molbio/maps/circular/RingComponent';
import {SegmentRingSelection} from 'molbio/maps/circular/SegmentsRingView';
import SequencePrimer from 'molbio/primers/backbone/SequencePrimer';
import {DASHED_LINE, SOLID_LINE} from 'util/SVGUtil';

class CircularPrimersView extends LabeledSegmentsRingView<RingLayout, SequencePrimer> {
  override className!: string;
  override singularClassName!: string;
  override tagName!: string;

  static initClass(): void {
    this.prototype.className = 'primers';
    this.prototype.singularClassName = 'primer';
    this.prototype.tagName = 'g';
  }

  override initialize(options: RingComponentOptions<RingLayout>): void {
    this.fill = this.fill.bind(this);
    super.initialize(options);
  }

  override contextMenuData(): Array<string> {
    return selectioncontextmenu.PRIMER_MENU;
  }

  override contextMenuOptions(d: SequencePrimer): MenuChoicesOptions {
    return {primer: d};
  }

  override arc(d: SequencePrimer): Arc<unknown, DefaultArcObject> {
    switch (d.strand()) {
      case 1:
        return arcs.forwardArrowArc();
      case -1:
        return arcs.backwardArrowArc();
    }
  }

  override fill(d: SequencePrimer): string {
    return `url(#stripe-${this.cid}-${d.uid()})`;
  }

  override data(): Array<SequencePrimer> {
    const sequence = this.model.get('sequence');
    return sequence.sequencePrimers().slice(0, sequence.length());
  }

  override registerListeners(): void {
    super.registerListeners();
    const primers = this.model.get('sequence').sequencePrimers();
    this.listenTo(primers, 'layerChange', function () {
      // @ts-expect-error shadows outer this
      this.invalidateData();
      // @ts-expect-error shadows outer this
      return this.triggerRedraw();
    });
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(primers, 'change:hover change:selected', this.handleHover);
  }

  clickAction(e: MouseEvent, d: SequencePrimer): void {
    d.click(this.model.get('sequence'), e.shiftKey);
  }

  dblClickAction(e: MouseEvent, d: SequencePrimer): void {
    d.dblClick(this.model.get('sequence'), e.shiftKey);
  }

  override setConstraints(outerRadius: number): void {
    this.setOuterRadius(outerRadius);
  }

  override redrawPlasmid(): boolean {
    return true;
  }

  override storeBounds(rings?: number | null): void {
    if (rings == null) {
      ({rings} = this);
    }
    this.rings = rings;
    const innerRadius = this.getOuterRadius() - this.layout.get('ringHeight') * this.rings!;
    this.layout.set('innerRadius', innerRadius);
    this.updateRadius();
  }

  override zeroBounds(): void {
    this.layout.set('innerRadius', this.layout.get('outerRadius'));
    this.updateRadius();
  }

  override layerBounds(layer: number): {innerRadius: number; outerRadius: number} {
    return {
      innerRadius: this.radiusIn(layer + 1),
      outerRadius: this.radiusIn(layer) - this.layout.vMargin(),
    };
  }

  override baseLine(layer: number): number {
    return this.radiusIn(layer + 2 / 3 + 1 / 6);
  } // FIXME: What is this magic

  override eachRing(root: SegmentRingSelection<SequencePrimer>): void {
    super.eachRing(root);
    root.attr('data-test-component', 'circularPrimersView');
    root.attr('data-test-element', 'primerRoot');
    root.attr('stroke-dasharray', (d) => (d.get('_primer').isNew() ? DASHED_LINE : SOLID_LINE));
    const pattern = root.select('defs').select('pattern');
    pattern.attr('id', (d) => `stripe-${this.cid}-${d.uid()}`);
    const patternRect = root.select('defs').select('pattern').select('rect');
    patternRect.attr('fill', (d) => d.color());
  }

  override enterRing(enter: SegmentRingSelection<SequencePrimer>): SegmentRingSelection<SequencePrimer> {
    super.enterRing(enter);
    const pattern = enter
      .append('svg:defs')
      .append('svg:pattern')
      .attr('patternUnits', 'userSpaceOnUse')
      .attr('width', 14)
      .attr('height', 14);
    pattern
      .append('svg:rect')
      .attr('width', 14)
      .attr('height', 14)
      .attr('fill', (d) => d.color());
    pattern
      .append('svg:path')
      .attr('fill', 'black')
      .attr('fill-opacity', '0.15')
      .attr('d', 'M5.232,17.089l-3.536-3.535L16.268-1.018l3.536,3.536L5.232,17.089z');
    pattern
      .append('svg:path')
      .attr('fill', 'black')
      .attr('fill-opacity', '0.15')
      .attr('d', 'M-1.839,10.018l-3.535-3.536L9.197-8.089l3.536,3.535L-1.839,10.018z');

    return enter;
  }

  override cutoffRadius(): number {
    return this.model.get('primerCutoffRadius')!;
  }

  override stroke(d: SequencePrimer): string {
    return d.outlineColor(this.model.get('sequence'));
  }
}
CircularPrimersView.initClass();

export default CircularPrimersView;
